// extracted by mini-css-extract-plugin
module.exports = {"box":"breedGlossary_box__oXUzM","title":"breedGlossary_title__D3PSO","species-card":"breedGlossary_species-card__OfaW3"};